angular.module('invoice')
    .component('invoiceBgtGroupPickerAll', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            modelType: '<?',
            placeholder: '@?',
            noneSelected: '<?',
            onChange: '&?',
            onNone: '&?'
        },
        templateUrl: "app/invoice/bgt-group/picker-all.html",
        controller: function (InvoiceBgtGroup){
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.placeholder = ctrl.placeholder || '-- grupa BGT --';
                ctrl.noneFeatureEnabled = angular.isFunction(ctrl.onNone)

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            }

            ctrl.refreshData = search => {
                let selectedId = null
                if(ctrl.modelType === "id" && ctrl.ngModelCtrl.$modelValue != null) {
                    selectedId = ctrl.ngModelCtrl.$modelValue;
                }
                else if(ctrl.modelType === "object" && ctrl.ngModelCtrl.$modelValue != null) {
                    selectedId = ctrl.ngModelCtrl.$modelValue.id;
                }

                let params = {
                    search: search,
                    size: 1000,
                    selectedId: selectedId,
                    filter: "with-parent"
                };
                InvoiceBgtGroup.autocomplete(params).$promise.then(items => {
                    this.items = items
                });
            }

            ctrl.bgtGroupFn = item => {
                if (item.parent && item.parent.id) {
                    return item.parent.name;
                }
                return null;
            }

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange(ctrl.selected);
                }
                // if (angular.isFunction(ctrl.onChange())) {
                //     ctrl.onChange()($item);
                // }
            };

            ctrl.toggleNone = () => {
                ctrl.noneSelected = ctrl.noneSelected === true ? null : true
                ctrl.onNone({$none: ctrl.noneSelected})
            }
        }
    })
